const e = "Aparthotels", s = "Apartments", t = "Business", o = "Campsites", n = "Couple", i = "Family", r = "Friends", a = "Hostels", l = "Hotels", m = "Resorts", u = "Restaurants", c = {
  "{num} reviews": "{num} reviews",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} in {location}",
  "All languages": "All languages",
  "All traveler types": "All traveler types",
  Aparthotels: e,
  Apartments: s,
  "Arrow icon": "Arrow icon",
  "B&Bs": "B&Bs",
  "based on {number} reviews": "based on {number} reviews",
  Business: t,
  Campsites: o,
  Couple: n,
  Family: i,
  Friend: r,
  "Highlighted reviews": "Highlighted Reviews",
  Hostels: a,
  Hotels: l,
  "Information icon": "Information icon",
  "No reviews found": "No reviews found",
  "Pet-friendly": "Pet-friendly",
  "Posted on {reviewer}": "Posted on {reviewer}",
  "Read Reviews": "Read Reviews",
  Resorts: m,
  Restaurants: u,
  "Review Summary": "Review Summary",
  "Reviews by Source": "Reviews by Source"
};
export {
  e as Aparthotels,
  s as Apartments,
  t as Business,
  o as Campsites,
  n as Couple,
  i as Family,
  r as Friend,
  a as Hostels,
  l as Hotels,
  m as Resorts,
  u as Restaurants,
  c as default
};
//# sourceMappingURL=en.CE6YGZTx.js.map
